import { NAME as APP_NAME } from 'domain/finance/constants';

export const NAME = `${APP_NAME}/DASHBOARD`;
export const REDUCER_NAME = 'dashboard';
export const ROUTES = {
  ROOT: '/finance/credit-terms',
  ROOT2: '/finance/invoices',
};
